export interface BaseEntityDto {
  id: string; // Guid
  createdAt: string; // DateTime as ISO string
  updatedAt?: string | null; // DateTime as ISO string
}
